import React from 'react';
import StageBackground from '../../../DeviationBackground/StageBackground';
import DeviationFullView from '../../../DeviationViews/Full';
import DuperbrowsePaddles from '../../../Duperbrowse/DuperbrowsePaddles';
import s from './SimpleStage.scss';
var SimpleStage = function (_a) {
    var deviation = _a.deviation;
    return (React.createElement("div", { className: s['stage'] },
        React.createElement(StageBackground, { deviation: deviation }),
        React.createElement("div", { className: s['stage-content'] },
            React.createElement(DeviationFullView, { deviation: deviation })),
        React.createElement(DuperbrowsePaddles, { className: s['duperbrowse'] })));
};
SimpleStage.displayName = 'SimpleStage';
export default SimpleStage;
//# sourceMappingURL=SimpleStage.js.map